export default function getTimeType(value: number): string {
  switch (value) {
    case 1:
      return "1º Turno";
    case 2:
      return "2º Turno";
    case 3:
      return "3º Turno";
    case 4:
      return "Comercial";
    default:
      return "Nunhum";
  }
}
